import { FunctionComponent, useContext, useMemo } from 'react';
import { Edge, Handle, NodeProps, Position, useEdges, useNodes } from 'reactflow';
import { Paper, Typography, Box, IconButton, lighten, useTheme } from '@mui/material';
import { EditorContext } from '../context';
import { ReactComponent as MachineIcon } from '../../../../assets/icons/main/machine-icon.svg';
import { ReactComponent as DeleteIcon } from '../../../../assets/icons/main/delete-icon.svg';
import { useOutletContext } from 'react-router-dom';
import { get } from 'lodash';
import { palette } from '../../../../theme/palette';
import { factoryManagementActions } from '../../../../store/reducers/factory-management';
import { useDispatch } from 'react-redux';
import ElipsisTypography from '../components/ElipsisTypography';
import NodeStatuses from './NodeStatuses';

// const Styles = {
//   nodeWrapper: {
//     width: '355px',
//     borderRadius: '18px',
//     borderBottom: '6px solid #8B85CB',
//   },
//   header: {
//     height: '79px',
//     display: 'flex',
//     alignItems: 'center',
//     padding: '24px 24px 14px 24px',
//     borderBottom: '1px dashed #8B85CB',
//     boxSizing: 'border-box',
//   },
//   machineIconWrapper: {
//     height: '42px',
//     width: '42px',
//     backgroundColor: '#8B85CB',
//     borderRadius: '50px',
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//   },
//   titleWrapper: {
//     display: 'flex',
//     alignItems: 'baseline',
//   },
//   title: {fontSize: 18, marginLeft: 1},
//   btnContainer: {
//     // height: '90px',
//     display: 'flex',
//     flexDirection: 'column',
//     justifyContent: 'space-around',
//     alignItems: 'center',
//     boxSizing: 'border-box',
//     padding: '24px',
//     spacing: 3
//   },
//   btn: {width: '307px', height: '42px', color: '#64759F', borderColor: '#64759F'},
// };

const Styles = {
  nodeWrapper: {
    height: '48px',
    position: 'relative',
    // border: '1px solid lightgrey',
    borderRadius: '12px',
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    overflow: 'hidden',
    width: '350px',
  },
  iconWrapper: {
    width: '48px',
    backgroundColor: palette.machineNode.main,
  },
  icon: {
    height: '48px',
    width: '48px',
  },
  handleSource: {
    height: '1px',
    width: '1px',
    backgroundColor: 'transparent',
    left: 0,
  },
  handleTarget: {
    height: '1px',
    width: '1px',
    backgroundColor: 'transparent',
    right: 0,
  },
};

export const MachineNode: FunctionComponent<NodeProps> = ({ id, data = {}, xPos, yPos, ...props }: NodeProps) => {
  const { onBtnClick, removeNode, editable, hasAccessTo, isLiveView } = useContext(EditorContext);
  const themeData: any = useTheme();
  const themeMode: any = get(useOutletContext(), 'themeMode', {});
  const nodes = useNodes();
  const node = nodes.find((node) => node.id === id);
  const dispatch = useDispatch();

  const hasReadOnlyAccess = !(hasAccessTo.create && hasAccessTo.update);

  const edges = useEdges();
  const thisEdge: Edge = useMemo(() => edges.find((edge: Edge) => edge.target === id) as Edge, [id, edges]);

  return (
    <>
      <Handle style={Styles.handleTarget} type='target' position={Position.Right} />
      <Paper
        elevation={0}
        sx={{
          ...Styles.nodeWrapper,
          border: `1px solid ${themeData.palette.customBorderColor.main}`,
          backgroundColor: themeMode.isLightBG
            ? themeData.palette.background.paper
            : lighten(themeData.palette.background.default, 0.2),
        }}
      >
        <Box sx={Styles.iconWrapper}>
          <IconButton
            style={Styles.icon}
            onClick={() => {
              onBtnClick('machineNode', { id, data });
              dispatch(factoryManagementActions.getAssetComponentsDataRequest(get(node, 'connectedTo')));
            }}
            disabled={hasReadOnlyAccess}
          >
            <MachineIcon style={{ color: palette.primary.contrastText }} />
          </IconButton>
        </Box>
        <Typography sx={{ fontSize: '1rem', marginLeft: 1 }}>
          <ElipsisTypography width={250}> {data.name ?? 'Machine'} </ElipsisTypography>
        </Typography>
        {editable ? (
          <IconButton disabled={!editable} onClick={() => removeNode(id)}>
            <DeleteIcon style={{ color: themeData.palette.custom.light, opacity: hasReadOnlyAccess ? '0.5' : 1 }} />
          </IconButton>
        ) : (
          <Box sx={{ width: 38 }} />
        )}

        {isLiveView && (
          <NodeStatuses
            statuses={{
              mqttStatus: thisEdge?.data?.mqttStatus,
              plcStatus: thisEdge?.data?.plcStatus,
              dbStatus: thisEdge?.data?.dbStatus,
            }}
            palette={themeData.palette}
          />
        )}
      </Paper>
    </>
  );

  // return (
  //   <>
  //     <Handle type="target" position={Position.Left} style={{top: '125px'}}/>
  //     <Paper elevation={3} sx={Styles.nodeWrapper}>
  //       <Box sx={Styles.header}>
  //         <Box sx={Styles.machineIconWrapper}>
  //           <MachineIcon/>
  //         </Box>
  //         <Box sx={Styles.titleWrapper}>
  //           <Typography sx={Styles.title}>{data.label}</Typography>
  //         </Box>
  //         <IconButton style={{position: 'absolute', right: 8}} onClick={() => removeNode(id)}><Delete/></IconButton>
  //       </Box>
  //       <Stack spacing={2} sx={Styles.btnContainer}>
  //         {data.machine_parts?.map((part: any) => <Button
  //           variant="outlined"
  //           sx={Styles.btn}
  //           onClick={() => {
  //             onBtnClick('machineNode', part);
  //           }}
  //         >
  //           {part.part_name}
  //         </Button>)}
  //       </Stack>
  //     </Paper>
  //     {/* <Handle type="source" position={Position.Right} /> */}
  //   </>
  // );
};
